var myStore = {
    debug: true,
    state: {
        deviceNo: "",
        mainUrl: "",
        manageUrl: "",
        cardNo: "",
        loginType: "",
        deviceToken: "",
        //错误页显示信息
        errorMessage: "",
        //是否在错误页面
        isErrorPage: false,
        //设备是否维护中
        isServering: false,
        //是否管理界面中
        isManageUrl: false,
    },
    setDeviceNoAction(newValue) {
        if (this.debug) console.log("setDeviceNoAction trigged with ", newValue);
        this.state.deviceNo = newValue;
    },
    clearDeviceNoAction() {
        if (this.debug) console.log("clearDeviceNoAction trigged");
        this.state.deviceNo = "";
    },
    setUrlAction(newValue, newValue2) {
        if (this.debug) console.log("setUrlAction trigged with ", newValue, newValue2);
        this.state.mainUrl = newValue;
        this.state.manageUrl = newValue2;
    },
    clearUrlAction() {
        if (this.debug) console.log("clearUrlAction trigged");
        this.state.mainUrl = "";
        this.state.manageUrl = "";
    },
    setCardNoAction(newValue) {
        if (this.debug) console.log("setCardNoAction trigged with ", newValue);
        this.state.cardNo = newValue;
    },
    clearCardNoAction() {
        if (this.debug) console.log("clearCardNoAction trigged");
        this.state.cardNo = "";
    },
    setLoginTypeAction(newValue) {
        if (this.debug) console.log("setLoginTypeAction trigged with ", newValue);
        this.state.loginType = newValue;
    },
    clearLoginTypeAction() {
        if (this.debug) console.log("clearLoginTypeAction trigged");
        this.state.loginType = "";
    },
    setDeviceTokenAction(newValue) {
        if (this.debug) console.log("setDeviceTokenAction trigged with ", newValue);
        this.state.deviceToken = newValue;
    },
    clearDeviceTokenAction() {
        if (this.debug) console.log("clearDeviceTokenAction trigged");
        this.state.deviceToken = "";
    },
    setErrorMessageAction(newValue) {
        if (this.debug) console.log("setErrorMessageAction trigged with ", newValue);
        this.state.errorMessage = newValue;
    },
    clearErrorMessageAction() {
        if (this.debug) console.log("clearErrorMessageAction trigged");
        this.state.errorMessage = "";
    },
    setIsErrorPageAction(newValue) {
        if (this.debug) console.log("setIsErrorPageAction trigged with ", newValue);
        this.state.isErrorPage = newValue;
    },
    clearIsErrorPageAction() {
        if (this.debug) console.log("clearIsErrorPageAction trigged");
        this.state.isErrorPage = false;
    },
    setIsServeringAction(newValue) {
        if (this.debug) console.log("setIsServeringAction trigged with ", newValue);
        this.state.isServering = newValue;
    },
    clearIsServeringAction() {
        if (this.debug) console.log("clearIsServeringAction trigged");
        this.state.isServering = false;
    },
    setIsManageUrlAction(newValue) {
        if (this.debug) console.log("setIsManageUrlAction trigged with ", newValue);
        this.state.isManageUrl = newValue;
    },
    clearIsManageUrlAction() {
        if (this.debug) console.log("clearIsManageUrlAction trigged");
        this.state.isManageUrl = false;
    }
};
export default myStore